// src/components/Teams.jsx
import React, { useState } from 'react';
import { Box, Grid, CardActionArea } from '@mui/material';
import TeamModal from './common/TeamModal';
import '../components/common/TeamsPage.css';

const gameCards = [
  { name: 'Counter Strike', position: 'top' },
  { name: 'League of Legends', position: 'top' },
  { name: 'Valorant', position: 'top' },
  { name: 'Mobile', position: 'bottom' },
  { name: 'Otros', position: 'bottom' },
];

const Teams = () => {
  const [selectedTeam, setSelectedTeam] = useState(null);

  const handleCardClick = (teamName) => {
    setSelectedTeam(teamName);
  };

  const handleCloseModal = () => {
    setSelectedTeam(null);
  };

  return (
    <Box className="teams-container">
      <div className="graffiti-text">EQUIPOS</div>
     
      {/* Top Row */}
      <Grid container spacing={4} justifyContent="center" mb={6}>
        {gameCards
          .filter((game) => game.position === 'top')
          .map((game) => (
            <Grid item key={game.name}>
  <Box display="flex" justifyContent="center">
    <CardActionArea
      onClick={() => handleCardClick(game.name)}
      sx={{ width: 220 }} // 🔥 ancho fijo
    >
      <div className="team-card">{game.name}</div>
    </CardActionArea>
  </Box>
</Grid>
          ))}
      </Grid>

      {/* Bottom Row */}
      <Grid container spacing={4} justifyContent="center">
        {gameCards
          .filter((game) => game.position === 'bottom')
          .map((game) => (
            <Grid item key={game.name}>
              <Box display="flex" justifyContent="center">
                <CardActionArea onClick={() => handleCardClick(game.name)}>
                  <div className="team-card">{game.name}</div>
                </CardActionArea>
              </Box>
            </Grid>
          ))}
      </Grid>

      {/* Modal */}
      <TeamModal
        open={!!selectedTeam}
        onClose={handleCloseModal}
        team={selectedTeam}
      />
    </Box>
  );
};

export default Teams;